module.exports = __webpack_public_path__ + "static/gallery3-5adbef1018132e160849d730218d0686.jpg";